/*  */
/* Auth services */
/*  */

import { app } from "./dbServices";
import * as Realm from "realm-web";

export const branchUserRegister = async ({ data, branchId }: any) => {
  if (!data) {
    throw new Error("No data provided for branch user registration.");
  }

  try {
    const result = await app.currentUser.callFunction("branchRegister", {
      data,
      branchId,
    });
    return result;
  } catch (error) {
    throw new Error(`Failed to register branch user: ${error}`);
  }
};
export const userRegister = async ({ data }: any) => {
  if (!data) {
    return;
  }
  if (!app || !app.currentUser) {
    const credentials = Realm.Credentials.anonymous();
    await app.logIn(credentials);
  }
  const result = await app.currentUser.callFunction("register", {
    data,
  });

  return result;
};

export const sendEmailAfterLogin = async ({ toEmail, currentApp }: any) => {
  if (!toEmail) {
    return;
  }

  const result = await currentApp.currentUser.callFunction("reSendEmail", {
    toEmail,
  });
  return result;
};

export const verifyOTP = async ({ email, submittedOtp, currentApp }: any) => {
  if (!email || !submittedOtp) {
    return;
  }

  const result = await currentApp.currentUser.callFunction("verifyOTP", {
    email,
    submittedOtp,
  });
  return result;
};
